
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRouter} from "vue-router";

    interface Photo {
        photoIdStr: string;
        smallPhotoUrl: string;
        photoName: string;
    }

    interface State {
        photoList: Array<Photo>;
        defectList: object[];
        listSumNumber: number; // 异常项数
        listTitle: string; // 检测异常项title
    }

    export default defineComponent({
        name: "AbnormalCheck",
        setup() {
            let state: State = reactive({
                photoList: [],
                defectList: [],
                listSumNumber: 0,
                listTitle: '异常检测项'
            })
            let store = useStore()
            // 获取路由器实例
            const router = useRouter()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {defectItem} = data;
                const {defectItemCount, itemList} = defectItem;
                state.defectList = itemList;
                state.listSumNumber = defectItemCount;
            })
            return {
                state,
                router
            }
        },
        methods: {
            goPhoto(item, isAll){
                this.router.push({
                    path: '/idlefishPhotoList',
                    name: 'idlefish-PhotoList',
                    // params: {
                    //     isAll,
                    //     checkItemId: 'defectPhoto',
                    //     item: JSON.stringify(item)
                    // }
                    query: {
                        isAll,
                        checkItemId: 'defectPhoto',
                        item: JSON.stringify(item)
                    }
                })
            },
            // 缺陷转译
            handleSignStatus(signRuleVOS: any, moduleCode: string) {
                let signone: any = [], signtwo: any = [], backValue = '', name = ''
                signRuleVOS.map((item: any) => {
                    if(item.sign == 1) {
                      signone.push(item.congValue)
                    } else {
                      signtwo.push(item.congValue)
                    }
                })
                if (moduleCode == 'accident') {
                    name = '重大事故'
                } else if (moduleCode == 'fire') {
                    name = '火烧'
                } else if (moduleCode == 'soakWater') {
                    name = '泡水'
                }
                if (signone.length > 0) {
                    backValue = '非' + name + '（' + signone.join('、') + '）'
                    backValue = this.handleBreakLine(backValue)
                }
                if (signtwo.length > 0) {
                    backValue = name + '（' + signtwo.join('、') + '）'
                    backValue = this.handleBreakLine(backValue)
                }
                if (signone.length > 0 && signtwo.length > 0) {
                    let oneword: string = name + '（' + signtwo.join('、') + '）',
                    twoword: string = '非'+ name + '（' + signone.join('、') + '）'
                    backValue = this.handleBreakLine(oneword) + '\n' + this.handleBreakLine(twoword)
                }
                return backValue
            },
            handleBreakLine(word: string) {
                if (word.length <= 22) {
                    return word
                } else {
                    return word.substring(0, 22) + '...'
                }
            },
        }
    })
